<template>
  <CrudForm :title="title" :labelSubmit="labelSubmit" :storeName="storeName" :parentStoreName="parentStoreName"
    :parentUrlKey="parentUrlKey" :submit="submit_message" :status="status" labelBack="Atrás" :urlBackSpot="urlBackSpot"
    :canCancel=false canCancelMessage>
    <ValidationObserver ref="validator" v-slot="{ }">
      <v-row justify="center">
        <v-col cols="6">
          <v-row>
            <v-col>
              <ValidationProvider ref="title" rules="required" v-slot="{ errors }">
                <v-text-field label="Titulo" :error-messages="errors" v-model="data.title" />
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <label>Descripción Push</label>
              <ValidationProvider ref="description" rules="required" v-slot="{ errors }">
                <v-textarea :error-messages="errors" v-model="data.description_push" solo rows="8">
                </v-textarea>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <label>Descripción Email</label>
              <ValidationProvider ref="description" rules="required" v-slot="{ errors }">
                <v-textarea :error-messages="errors" v-model="data.description_email" solo rows="8">
                </v-textarea>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from "@/mixins/crud_form";
import swal from "sweetalert";
export default {
  mixins: [CrudFormMixin],
  components: {
    ValidationProvider,
    ValidationObserver,
    CrudForm,
  },
  computed: {
    ...mapState({
      status: (state) => state.Spots.status,
    }),
  },
  async created() {
    const { user_id, spot_id } = this.$route.params;
    const { name } = this.$route.query;
    if (user_id && spot_id && name) {
      this.title = "Enviar notificacion: " + name;
      this.data.user_id = user_id;
      this.data.spot_id = spot_id;
    }
    this.urlBackSpot = '/admin/users/' + user_id + '/spots/edit/' + spot_id
  },
  data() {
    return {
      parentStoreName: "Users",
      parentUrlKey: "user_id",
      storeName: "Spots",
      title: "Message",
      data: {
        user_id: "",
        title: "Soporte IZI Park",
        description_push: "",
        description_email: "",
        spot_id: "",
        type: "Rechazo",
      },
      urlBackSpot: "",
    };
  },
  watch: {},
  methods: {
    async submit_message() {
      const self = this;
      let valid = await self.$refs.validator.validate();
      if (valid) {
        let saveUrl = `${this.storeName}/create_message`;
        self.$store
          .dispatch(saveUrl, self.data)
          .then(function () {
            swal("Notificación Enviada", "exitosamente!!", "success", {
              timer: 3000,
            });
            self.$router.push(self.urlBackSpot);
          })
          .catch(function (response) {
            for (const i in response.errors) {
              try {
                eval("self.$refs." + i + ".setErrors(response.errors[i]);");
              } catch (error) {
                //
              }
            }
          });
      }
    },
  },
};
</script>
